// extracted by mini-css-extract-plugin
export default {"searchbar":"styles_searchbar__CMg8I","cat":"styles_cat__yNMmu","input":"styles_input__IplHt","btn":"styles_btn__1KTgp"};